import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ATSReferenceCheckDataTestIds } from 'data-testids/ATS';
import { PrimaryButton } from 'sharedComponents/Buttons/PrimaryButton';
import { ReferenceCheckModal } from '../ReferenceCheckModal';
import { primaryButtonOverrideSx } from 'sharedComponents/Buttons/styles';

interface ReferenceCheckSectionProps {
  jobId: number;
}

export const ReferenceCheckSection: React.FC<ReferenceCheckSectionProps> = ({ jobId }) => {
  const theme = useTheme();
  const [showModal, setShowModal] = useState(false);

  const handleSetupClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <Box
      data-testid={ATSReferenceCheckDataTestIds.REFERENCE_CHECK_SECTION}
      sx={{
        backgroundColor: theme.palette.grey[50],
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(3),
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(5),
      }}
    >
      <Typography
        data-testid={ATSReferenceCheckDataTestIds.REFERENCE_CHECK_TITLE}
        variant="h3"
        sx={{
          color: theme.palette.text.primary,
          fontWeight: theme.typography.fontWeightMedium,
          marginBottom: theme.spacing(1),
        }}
      >
        Reference Checks
      </Typography>

      <Typography
        data-testid={ATSReferenceCheckDataTestIds.REFERENCE_CHECK_DESCRIPTION}
        variant="body1"
        sx={{
          color: theme.palette.text.secondary,
          marginBottom: theme.spacing(2),
          lineHeight: 1.5,
        }}
      >
        Automatically send reference check emails to a candidate&apos;s reference contacts when they
        reach a specific status.
      </Typography>

      <PrimaryButton
        dataTestId={ATSReferenceCheckDataTestIds.SET_UP_AUTO_REFERENCE_BUTTON}
        onClick={handleSetupClick}
        sx={{
          ...primaryButtonOverrideSx(theme),
          backgroundColor: theme.palette.success.main,
          '&:hover': {
            backgroundColor: theme.palette.success.dark,
          },
        }}
      >
        Set up auto reference check
      </PrimaryButton>

      <ReferenceCheckModal
        open={showModal}
        onClose={handleCloseModal}
        jobId={jobId}
        onSuccess={(formData) => {
          console.log('Reference check automation created:', formData);
        }}
      />
    </Box>
  );
};
